

<div class="Dialog-body">  
  <div> 
    <i class="material-icons ttmodal__close-button" style="margin-left: 95%; cursor: pointer;" (click)="onCloseClick()">close</i>
</div>            
  <span >{{Crackcomment}}</span>
  <div style="margin-top: 10%;"></div>

</div>
